import { gql } from 'apollo-boost';

const invoiceBatchSummaryCardQuery = gql`
  query invoiceBatchSummaryCard($orgId: ID!) {
    remittanceBatch {
      carrierBatches(
        orgId: $orgId
        limit: 1
        sortDetails: { sortByPropertyName: "createdUtc", sortAscending: false }
      ) {
        results {
          totalAmountDue
          createdUtc
        }
      }
      totals(orgId: $orgId) {
        totalBatches
        totalInvoices
      }
    }
  }
`;

const carrierPerformanceSummaryCardQuery = gql`
  query carrierPerformanceSummaryCard($orgId: Int!) {
    carrier {
      onTimeStats(orgId: $orgId, summarize: true) {
        numDelivered
        numPickedUp
        percentOnTimeForDelivery
        percentOnTimeForPickup
      }
    }
  }
`;

export const retrieveInvoiceBatchSummaryCardData = async (
  orgId,
  ApolloClient
) => {
  const {
    data: { remittanceBatch }
  } = await ApolloClient.query({
    query: invoiceBatchSummaryCardQuery,
    variables: { orgId: orgId }
  });

  const lastBatch =
    remittanceBatch.carrierBatches.results.length > 0
      ? remittanceBatch.carrierBatches.results[0]
      : { totalAmountDue: 0, createdUtc: null };

  const batchCount =
    remittanceBatch.totals != null
      ? remittanceBatch.totals
      : { totalBatches: 0, totalInvoices: 0 };

  return {
    lastBatch,
    batchCount
  };
};

export const retrieveCarrierPerformanceSummaryCardData = async (
  orgId,
  ApolloClient
) => {
  const {
    data: {
      carrier: { onTimeStats }
    }
  } = await ApolloClient.query({
    query: carrierPerformanceSummaryCardQuery,
    variables: { orgId: orgId }
  });
  const result =
    onTimeStats.length > 0
      ? onTimeStats[0]
      : {
          numDelivered: 0,
          numPickedUp: 0,
          percentOnTimeForDelivery: 0,
          percentOnTimeForPickup: 0
        };

  return result;
};
